<template>
  <div>
    <div class="p-2 mt-1">
      <validation-observer ref="docForm">
        <div class="row py-4 px-5">
          <div class="col-12 mb-3">
            <em class="fas fa-file-upload  text-orange mr-2" />
            <span class="font-weight-bold">Anejar Carta Firmada</span>
          </div>
          <div class="col-12 mb-4 bg-white p-3 rounded">
            <div class="row">
              <div class="col-12 col-lg-4">
                <div class="color-secondary-6 font-14">
                  Tipo de Documento:
                </div>
                <div class="font-weight-normal color-black font-16">
                  {{ title }} Firmada
                </div>
              </div>
              <div class="col-12 col-lg-4">
                <div class="color-secondary-6 font-14">
                  Archivo:
                </div>
                <div class="font-weight-normal color-black font-16">
                  {{ model.signatureFile?.name | empty }}
                </div>
              </div>
              <div
                class="col-12 col-lg-4 d-flex justify-content-end align-items-center"
              >
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-file-input
                    ref="fileUpload"
                    v-model="model.signatureFile"
                    :accept="allowedFiles"
                    class="mt-4 pt-1"
                    custom-error-msg="Favor seleccionar un documento."
                    display-style="normal"
                    :error="errors[0]"
                    label=""
                    label-position="left"
                    :max-size="100"
                    :on-download="() => {}"
                    required
                  />
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="col-12 d-flex justify-content-end align-items-center">
            <action-button
              i="fas fa-times-circle"
              text="Cancelar"
              variant="outline-danger mr-3 px-3"
              @click="$emit('cancel')"
            />
            <action-button
              i="fas fa-save"
              text="Guardar"
              variant="success px-3"
              @click="save"
            />
          </div>
        </div>
      </validation-observer>
    </div>
  </div>
</template>
<script>
import CustomFileInput from 'CustomFileInput';

export default {
  name: 'AddLetterDoc',
  components: {
    CustomFileInput,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      default: 'Carta de Determinación',
    },
  },
  data: () => ({
    allowedFiles: '.pdf',
  }),
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async save() {
      const isValid = await this.$refs.docForm.validate();
      if (!isValid) return;
      this.$emit('save');
    },
  },
};
</script>
<style lang=""></style>
